import type { BurndownChartProps } from "@/types/burndown.types";

/** Illustrative chart inputs for landing-page product previews (not user data). */
export function getLandingSampleChartData(): BurndownChartProps["data"] {
  const startDate = new Date("2024-01-01");
  const endDate = new Date("2028-12-31");

  const expenses = [
    {
      id: "1",
      startDate: new Date("2024-01-01"),
      monthlyAmount: 5000,
      category: "Salary",
      name: "Developer Salary",
      color: "#dc2626",
    },
    {
      id: "2",
      startDate: new Date("2024-02-01"),
      monthlyAmount: 1500,
      category: "Marketing",
      name: "Google Ads",
      color: "#059669",
    },
    {
      id: "3",
      startDate: new Date("2024-03-01"),
      monthlyAmount: 800,
      dayOfMonth: 20,
      category: "Operations",
      name: "Office Rent",
      color: "#d97706",
    },
    {
      id: "4",
      startDate: new Date("2024-06-01"),
      endDate: new Date("2024-12-01"),
      monthlyAmount: 1200,
      category: "Product",
      name: "Software Licenses",
      color: "#7c3aed",
    },
    {
      id: "5",
      startDate: new Date("2024-09-01"),
      monthlyAmount: 3000,
      category: "Salary",
      name: "Marketing Manager",
      color: "#dc2626",
    },
  ];

  const revenues = [
    {
      id: "r1",
      name: "Monthly SaaS Revenue",
      category: "sales" as const,
      monthlyAmount: 2000,
      startDate: new Date("2024-02-01"),
      endDate: new Date("2025-02-01"),
      isRecurring: true,
      dayOfMonth: 5,
      frequency: "monthly" as const,
      color: "#10b981",
    },
    {
      id: "r1.1",
      name: "Monthly SaaS Revenue",
      category: "sales" as const,
      monthlyAmount: 10000,
      startDate: new Date("2025-03-01"),
      isRecurring: true,
      dayOfMonth: 5,
      frequency: "monthly" as const,
      color: "#10b981",
    },
    {
      id: "r2",
      name: "Consulting Services",
      category: "sales" as const,
      monthlyAmount: 3000,
      startDate: new Date("2024-04-01"),
      endDate: new Date("2024-08-01"),
      isRecurring: true,
      frequency: "monthly" as const,
      color: "#3b82f6",
    },
  ];

  const events = [
    {
      id: "1",
      date: new Date("2024-08-01"),
      type: "funding" as const,
      priority: "high" as const,
      description: "Seed funding round - $250K",
      amount: 250000,
      icon: "DollarSign",
      color: "#16a34a",
    },
    {
      id: "2",
      date: new Date("2024-10-01"),
      type: "launch" as const,
      priority: "medium" as const,
      description: "Product launch",
      icon: "Rocket",
      color: "#dc2626",
    },
    {
      id: "3",
      date: new Date("2025-03-01"),
      type: "milestone" as const,
      priority: "low" as const,
      description: "Break-even target",
      icon: "Target",
      color: "#7c3aed",
    },
  ];

  return {
    startDate,
    endDate,
    initialBalance: 100000,
    expenses,
    events,
    revenues,
  };
}

export const LANDING_SAMPLE_PREVIEW_DATE = new Date("2024-08-15");

export const LANDING_SAMPLE_VISIBLE_RANGE = {
  startDate: new Date("2024-01-01"),
  endDate: new Date("2025-06-30"),
};
